import {login } from './login'
import { GET } from './login'
import { logoutGet } from './login'
import {getData } from './login'
import {getCity } from './login'
import {getMenu } from './login'
import {POST } from './login'
import {search } from './login'
//登录
export const loginUser = p => login('/auth/oauth/token', p);


export const weixinLogin = p => login('/auth/weixin/token?grant_type=weixin&scope=server&weixin='+p);



export const weixinBind = p => POST('/admin/user/bindCurrent/wx/'+p);



//修改密码
export const updatePassWord = p => POST('admin/user/updatePassword', p);



//退出
export const logout = () => logoutGet('/auth/token/logout');
//获取用户信息
export const getinfo = p => GET('admin/user/info', p);
//获取用户菜单
export const getmenu = p => GET('admin/menu/getUserSysMenu', p);



export const getBatchSuyuanNodeDetailData = p => GET('business/batchsuyuannodedata/getBatchSuyuanNodeDetailData/'+ p);

//新增用户
export const addUser1 = p => POST('admin/user', p);
export const saveComplaininfo = p => POST('portal/gov/saveComplaininfo', p);

//溯源
export const batchsuyuannodedata = p => POST('business/batchsuyuannodedata',p);
export const saveDefaultTemp = p => POST('business/suyuantempnode/saveDefaultTemp/'+p);
export const getBatchSuyuanNodeContentVO= p => getData('business/batchsuyuannodedata/getBatchSuyuanNodeContentVO/'+p);//机构详情
export const getSuyuanTempNodeContentList= p => getData('business/suyuantempnodecontent/getSuyuanTempNodeContentList/'+p);//机构详情
//新增机构
export const addUser2 = p => POST('admin/organization/save', p)
//新增品牌
export const addUser3 = p => POST('business/brand', p);
//新增产品分类
export const addUser4 = p => POST('business/productcategory', p);
export const deleteCategor = p => POST('business/productcategory/delete/'+ p);
//新增产品分类
export const addUser5 = p => POST('business/product', p);
//新增批次
export const addUser6 = p => POST('business/batch', p);
//新增溯源节点列表
export const addUser7 = p => POST('business/suyuantemplate', p);
//生成码
export const addUser8 = p => POST('business/zymgen/genZym', p);
//码分配
export const addUser9 = p => POST('business/zymallot/allot', p);
//提交申请
export const addUser10 = p => POST('business/zymallot/apply', p);
//提交码关联
export const addUser11 = p => POST('business/zymjoin/join', p);
//重置码关联
export const addUser12 = p => POST('business/zymjoin/empty', p);

//保存讲师信息
export const addLecturer = p => POST('expand/lecturerresource/save', p);
export const deleteLecturer = p => POST('expand/lecturerresource/delete/'+ p);


export const addcompanyapply = p => POST('business/companyapply/handle', p);



//保存邀课记录
export const addInvitationRecord = p => POST('expand/invitationrecordresource/save', p);
export const deleteInvitationRecord = p => POST('expand/invitationrecordresource/delete/'+ p);

//保存安装师傅信息
export const addWorker = p => POST('expand/workerresource/save', p);
export const deleteWorker = p => POST('expand/workerresource/delete/'+ p);



//保存资讯信息
export const addNoticeinfo = p => POST('expand/noticeinfo/save', p);
export const deleteNoticeinfo = p => POST('expand/noticeinfo/delete/'+ p);



//保存资讯信息
export const addNewinfo = p => POST('expand/newinfo/save', p);
export const deleteNewinfo = p => POST('expand/newinfo/delete/'+ p);

//保存友情链接
export const addBlogroll = p => POST('expand/blogroll/save', p);
export const deleteBlogroll = p => POST('expand/blogroll/delete/'+ p);
//保存友情链接
export const addAreaResource = p => POST('expand/arearesource/save', p);
export const deleteAreaResource = p => POST('expand/arearesource/delete/'+ p);


//投入设备
export const addDeviceInfo = p => POST('business/deviceinfo/save', p);
export const deleteDeviceInfo = p => POST('business/deviceinfo/delete/'+ p);


//保存友情链接
export const addInput = p => POST('expand/input/save', p);
export const deleteInput = p => POST('expand/input/delete/'+ p);


//保存大数据
export const addModal = p => POST('expand/modal/save', p);

//投诉建议
export const addComplaininfo = p => POST('expand/complaininfo/dispose', p);



export const addCustom = p => POST('business/custom/save', p);
export const deleteCustom = p => POST('business/custom/delete/'+ p);


export const deleteBranchs = p => POST('business/brand/delete/'+ p);
export const deleteBatch =p => POST('business/batch/delete/'+ p);
export const deleteProduct =p => POST('business/product/delete/'+ p);
export const deleteTemplate =p => POST('business/suyuantemplate/delete/'+ p);
export const deleteBSND =p => POST('business/batchsuyuannodedata/delete/'+ p);





//保存摄像头
export const addmonitoringdeviceinfo = p => POST('device/monitoringdeviceinfo', p);


export const getmonitoringdevicelist = p => getData('device/monitoringdeviceinfo/page', p);
export const getmonitoringdeviceinfo = p => getData('device/monitoringdeviceinfo/' + p);
//机构详情


export const startPushStream =p => GET('device/monitoringdeviceinfo/startPushStream/'+ p);
export const stopPushStream =p => GET('device/monitoringdeviceinfo/stopPushStream/'+ p);
export const refresh =p => GET('device/monitoringdeviceinfo/refresh');

//保存摄像头
export const addweatherdevice = p => POST('device/weatherdeviceinfo', p);
export const getweatherdevicelist = p => getData('device/weatherdeviceinfo/page', p);
export const getweatherdeviceinfo= p => getData('device/weatherdeviceinfo/'+p);//机构详情


//获取菜单
export const getMenus = p => GET('admin/menu', p);
//获取城市
export const getCitys = p => getCity('admin/orgarea/findTree');
//获取城市
export const areaList = p => getData('admin/orgarea/getArealisttoparentid/'+p);

//机构列表
export const getDatas1 = p => getData('admin/organization/page', p);
export const getOrgDetail = p => getData('admin/organization/'+p);//机构详情
//品牌列表
export const branchs = p => getData('business/brand/page', p);

//获取机构品牌
export const brand_list = p => getData('business/brand/list/'+p);
//产品列表
export const broducts = p => getData('business/product/page', p);
export const productmodel = p => getData('business/product/'+ p);

//投入设备
export const deviceInfoList = p => getData('business/deviceinfo/page', p);
export const deviceInfoModel = p => getData('business/deviceinfo/'+ p);
export const deviceInfoMaxCode = p => getData('business/deviceinfo/getMaxCode', p);


//产品分类列表
export const broduct_type = p => getData('business/productcategory/getCategoryTree', p);
//产品批次列表
export const batchs = p => getData('business/batch/page', p);
export const batchsModel = p => getData('business/batch/'+ p);
//溯源节点列表
export const sources = p => getData('business/suyuantemplate/page', p);
//生成码列表
export const creat_code = p => getData('business/zymgen/page', p);
//获取机构下拉框
export const organization_list = p => getData('admin/organization/getOrgList', p);
//码机构列表
export const organization_list1 = p => getData('admin/organization/getParentOrgMap', p);
//产品父类列表
export const product_parent = p => getData('business/productcategory/getCategoryByOneLevel', p);
//获取产品列表字典
export const product_zd = p => getData('business/product/getProductMap', p);
export const product_map_orgid = p => getData('business/product/getProductToOrgId/'+ p);



//根据类型获得字典数据
export const dict_list = p => getData('admin/dict/type/'+p);



//讲师列表
export const lecturer = p => getData('expand/lecturerresource/page', p);
export const lecturermodel = p => getData('expand/lecturerresource/'+p);



export const companyapply = p => getData('business/companyapply/page', p);
export const companyapplymodel = p => getData('business/companyapply/'+p);


export const customList = p => getData('business/custom/page', p);
export const customModel = p => getData('business/custom/'+p);

//邀课记录
export const invitationrecord = p => getData('expand/invitationrecordresource/page?id='+p);
export const invitationrecordmodel = p => getData('expand/invitationrecordresource/'+p);


//安装师傅
export const workerrecord = p => getData('expand/workerresource/page',p);
export const workermodel = p => getData('expand/workerresource/'+p);

//导出
export const dowmOrgList = p => POST('gen/orgexecl/exportExcel', p);  //下载机构



//信息
export const noticeList = p => getData('/expand/noticeinfo/page',p);
export const noticeinfoModel = p => getData('expand/noticeinfo/'+p);
//信息
export const newList = p => getData('/expand/newinfo/page',p);
export const newinfoModel = p => getData('expand/newinfo/'+p);
//友情链接
export const blogrollList = p => getData('/expand/blogroll/page',p);
export const blogrollModel = p => getData('expand/blogroll/'+p);
//区域资源
export const areaResourceList = p => getData('/expand/arearesource/page',p);
export const areaResourceModel = p => getData('expand/arearesource/'+p);


//投诉建议
export const complaininfoList = p => getData('/expand/complaininfo/page',p);
export const complaininfoModel = p => getData('expand/complaininfo/' + p);


//index 首页 资讯
export const getNoticeList = p => POST('expand/noticeinfo/showNoticeList', p);
export const showDetails = p => getData('expand/noticeinfo/show/' + p);




//大数据
export const modalList = p => getData('expand/modal/page',p);
export const modalModel = p => getData('expand/modal/'+p);


//投入品
export const inputList = p => getData('expand/input/page',p);
export const inputModel = p => getData('expand/input/'+p);



// 生成吗
export const getticket = p => POST('portal/suyuan/getticket',p);



export const getOpenId = p => getData('portal/webchat/getopnid/'+p);



//修改密码
export const saveSuyuanRecord = p => POST('portal/suyuan/saveSuyuanRecord', p);



export const addlogistics = p => POST('business/logistics/save', p);
//获取机构品牌





// WEBPACK FOOTER //
// ./src/api/bapi.js